import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBr7v6gYINkVKpmHUUnQlOgX1e_ssl_zkc",
  authDomain: "misu-capital.firebaseapp.com",
  projectId: "misu-capital",
  storageBucket: "misu-capital.appspot.com", // fixed ".app" to ".appspot.com"
  messagingSenderId: "632150668348",
  appId: "1:632150668348:web:16f207915145b6d6e87f39",
  measurementId: "G-VZGB529KS6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const analytics = getAnalytics(app);

export { db, analytics };
